import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../i18n/useLanguage";
import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { KeyValue } from "../../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../../ui/PriceDisplay/PriceDisplay";
import { getPartName } from "../../../../util/getPartName";
import { PriceSelectEntry } from "../../../PriceSelect/usePriceSelectState";
import { usePricing } from "../../../PriceSelect/usePricing";
import { QuantitySelect } from "../../../QuantitySelect/QuantitySelect";
import { partIsStaggered } from "../../../Tires/Results/Filters/TireSizeFilters/partIsStaggered";
import { CartButtonCombo } from "./CartButtonCombo";

export const PriceBox: FunctionComponent<{
  isMd?: boolean;
  quantity: number;
  setQuantity: (quantity: number) => void;
  setTirePriceOption: (entry: PriceSelectEntry[]) => void;
  setWheelPiceOption: (entry: PriceSelectEntry[]) => void;
  tire?: TirePartItem;
  tirePriceOption: PriceSelectEntry[];
  vehicleId: null | number;
  wheel?: WheelPartItem;
  wheelPriceOption: PriceSelectEntry[];
}> = ({
  isMd,
  quantity,
  setQuantity,
  setTirePriceOption,
  setWheelPiceOption,
  tire = null,
  tirePriceOption,
  vehicleId,
  wheel = null,
  wheelPriceOption,
}) => {
  const [language] = useLanguage();
  const { t } = useTranslation();

  console.log("tirePriceOption: ", tirePriceOption);

  const wheelPricing = usePricing({
    defaultQuantity: quantity.toString(),
    isStaggered: false,
    onReady: setWheelPiceOption,
    part: wheel,
  });

  const tirePricing = usePricing({
    defaultQuantity: quantity.toString(),
    isStaggered: partIsStaggered(tire),
    onReady: setTirePriceOption,
    part: tire,
  });

  if (!tire || !wheel) {
    return null;
  }

  return (
    <div className={clsx("combo__pricebox", isMd && "combo__pricebox--lg")}>
      <h4>
        {t("searchResults.youChoose")}
        <span>:</span>
      </h4>
      <KeyValue className="combo__pricebox--wheel">
        <> {t("searchResults.wheel")}:</>
        <>{getPartName(wheel, language)}</>
      </KeyValue>
      <KeyValue className="combo__pricebox--tire">
        <> {t("searchResults.tire")}:</>
        <>{getPartName(tire, language)}</>
      </KeyValue>
      {wheelPricing.entries.map(
        ([combinedPartWheel, selectedPriceOption, setPricingIndex], key) => {
          return (
            <QuantitySelect
              // busy={busy}
              onChange={(next): void => {
                setWheelPiceOption(next);
                const nextQuantity = next[0].pricingOption.quantity;

                const tirePriceOptions = tirePricing.entries.map(
                  ([combinedPartTire]) => ({
                    combinedPart: combinedPartTire,
                    pricingOption: combinedPartTire.pricingOptions.find(
                      (e) => Number(e.quantity) === Number(nextQuantity)
                    ),
                  })
                );

                setTirePriceOption(tirePriceOptions as PriceSelectEntry[]);
                setQuantity(Number(nextQuantity));
              }}
              // disabled={disabled}
              entries={wheelPricing.entries}
              entryIndex={0}
              key={key}
              part={wheel}
              pricingOptions={combinedPartWheel.pricingOptions}
              selectedPriceOption={selectedPriceOption}
              setPricingIndex={setPricingIndex}
            />
          );
        }
      )}
      <KeyValue>
        <>{t("priceSelect.price")}:</>
        <PriceDisplay>{wheelPricing.total + tirePricing.total}</PriceDisplay>
      </KeyValue>
      <CartButtonCombo
        className="combo__cart_button"
        tire={tire}
        tirePricing={tirePriceOption}
        vehicleId={vehicleId}
        wheel={wheel}
        wheelPricing={wheelPriceOption}
      />
    </div>
  );
};
